<template>
  <v-app>
    <v-main>
      <AppBar :type="appBarType" :titlePage="appBarTitle" />
      <transition>
        <router-view></router-view>
      </transition>
      <BottomNavigation :type="bottomNavigationType" />
    </v-main>
  </v-app>
</template>

<script>
import BottomNavigation from './components/BottomNavigation';
import AppBar from './components/AppBar';

export default {
  metaInfo() {
    return {
      title: 'Semua kebutuhan event kampus',
      titleTemplate: '%s - Eventversity',
      htmlAttrs: {
        lang: 'id',
        amp: true,
      },
      meta: [
        {
          name: 'description',
          content:
            'Event marketing platform untuk semua kebutuhan kampus dengan sertifikat digital dan pembayaran mudah',
        },
        {
          property: 'og:title',
          content: 'Semua kebutuhan event kampus - Eventversity',
        },
        { property: 'og:site_name', content: 'Eventversity' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' },
      ],
    };
  },
  name: 'App',
  components: {
    AppBar,
    BottomNavigation,
  },
  data() {
    return {
      appBarType: 'default',
      appBarTitle: 'default',
      bottomNavigationType: true,
    };
  },
  watch: {
    // $route: {
    //   handler: to => {
    //     document.title = to.meta.title || 'Event UMB';
    //   },
    //   immediate: true,
    // },
    '$route.meta.AppBarNav': function (val) {
      this.toggleAppBar(val);
    },
    '$route.meta.title': function (val) {
      this.toggleAppBarTitle(val);
    },
    '$route.meta.BottomNav': function (val) {
      this.toggleBottomNav(val);
    },
  },
  methods: {
    toggleAppBar(type) {
      this.appBarType = type;
    },
    toggleAppBarTitle(val) {
      this.appBarTitle = val;
    },
    toggleBottomNav(type) {
      this.bottomNavigationType = type;
    },
  },
};
</script>

<style scoped>
.v-content {
  padding: 56px 0px 56px !important;
}
</style>
